import { StoreItemDTO } from '../stores/type';

export interface FranchiseFormDTO {
  name: string;
  logo: string;
  userId: string;
  description: string;
  timezone: string;
  averageBasket?: number;
  currencyCode: string;
  codeAlpha3: string;
  senderId: string;
  isPartner?: boolean;
}

export interface ClientQualificationDTO {
  id: string;
  lostCustomers: {
    timeSinceLastVisit: string;
  };
}
export interface ThemeDTO {
  primaryColor: string;
  secondaryColor: string;
  tertiaryColor: string;
}
export interface FranchiseInDTO {
  id: string;
  description: string;
  isOfficial: boolean;
  logo: string;
  dateCreated: string;
  lastModified: string;
  disabledAt?: string;
  name: string;
  userId: string;
  currencyCode: string;
  averageBasket: number;
  customersQualification?: ClientQualificationDTO;
  storeListId: string;
  timezone?: string;
  codeAlpha3: string;
  senderId: string;
  theme: ThemeDTO;
  features?: FranchiseFeatureType[];
  /** Write-only: sent on creation, never returned. Read it with `getFranchisePartnerApi`. */
  isPartner?: boolean;
}

/** The franchise read payload never carries the partner marker: only its admin endpoint does. */
export interface FranchisePartnerDTO {
  id: string;
  isPartner: boolean;
}

export interface FranchiseWithStoresDTO extends FranchiseInDTO {
  stores: StoreItemDTO[];
  storeIds: string[];
}

export interface FranchiseDetails extends FranchiseInDTO {
  customersQualification?: ClientQualificationDTO;
}

export interface FranchiseUpdateOutDTO {
  logo?: string;
  name?: string;
  description?: string;
  codeAlpha3?: string;
  currencyCode?: string;
  timezone?: string;
  averageBasket?: number;
  senderId?: string;
}

export enum SenderIdErrorType {
  SENDER_ID_EMPTY = 'SENDER_ID_EMPTY',
  SENDER_ID_CONTAINS_SPACES = 'SENDER_ID_CONTAINS_SPACES',
  SENDER_ID_TOO_LONG = 'SENDER_ID_TOO_LONG',
  SENDER_ID_NOT_ALPHANUMERIC = 'SENDER_ID_NOT_ALPHANUMERIC',
  SENDER_ID_NOT_ALLOWED = 'SENDER_ID_NOT_ALLOWED',
}

export enum FranchiseDialogType {
  NEW = 'new',
  EDIT = 'edit',
}

export enum FranchiseFeatureType {
  GAME = 'GAME',
  UBERALL = 'UBERALL',
  PRONO = 'PRONO',
  PRODUCT_CATEGORY_ANALYTICS = 'PRODUCT_CATEGORY_ANALYTICS',
  CRM_CONNECTORS = 'CRM_CONNECTORS',
  PARTIAL_CLIENTS = 'PARTIAL_CLIENTS',
}

export enum ApiKeyFeatureType {
  ADD_USER = 'ADD_USER',
}

export interface ConversionRateDTO {
  mobile: number;
  webapp: number;
  emarketing: number;
  manual: number;
}

export interface ApiKeyDTO {
  apiKey: string;
}

export interface AccessDTO {
  franchiseId: string;
  storeId?: string;
  permissions: ApiKeyFeatureType[];
}

export interface FranchiseSmsPriceDTO {
  isAvailable: boolean;
  unitPrice: number | null;
}

export interface ReachableFranchiseDTO {
  id: string;
  name: string;
  logo?: string;
  description?: string;
  /** The franchise owner a delegated session is opened as. */
  ownerUserId: string;
  /** True for the brand the caller's own permission resolves to. */
  isOwn: boolean;
}

export interface ConnectFranchiseDTO {
  token: string;
  franchiseId: string;
  ownerUserId: string;
}
